import { Fragment } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Link } from 'foundations-components/transitional/components/Link';
import OptionsTable from 'ui-forms-components/options/OptionsTable';
import OptionsTableFooter from 'ui-forms-components/options/OptionsTableFooter';
import { getPaymentLinksUrl } from 'FormsUI/lib/RouteGenerators';
import { CommentableArea } from 'collaboration-sidebar';
import DisableAddOptionReason from './DisableAddOptionReason';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PaymentOptionsTableWrapperHeader = () => /*#__PURE__*/_jsx("thead", {
  "data-test-id": "payment-options-table-header",
  children: /*#__PURE__*/_jsxs("tr", {
    children: [/*#__PURE__*/_jsx("th", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "editor.options.payment.options.preselectLabel"
      })
    }), /*#__PURE__*/_jsx("th", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "editor.options.payment.paymentLink"
      })
    }), /*#__PURE__*/_jsx("th", {})]
  })
});
const PaymentOptionsTableWrapper = ({
  paymentField,
  disableAddPaymentOption,
  addPaymentOption,
  updatePaymentField,
  showAllOptions,
  setShowAllOptions,
  renderPaymentSelectColumn,
  disableReason
}) => /*#__PURE__*/_jsx(CommentableArea, {
  moduleId: 'payment-options-table',
  description: {
    translationKey: 'formsPaymentPropertyOptions'
  },
  children: /*#__PURE__*/_jsx("div", {
    "data-test-id": "config-input-field",
    children: /*#__PURE__*/_jsx(FormControl, {
      help: /*#__PURE__*/_jsx(Link, {
        external: true,
        href: getPaymentLinksUrl(),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'editor.options.payment.configPanel.paymentLink'
        })
      }),
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'editor.form.properties.createNewFieldSection.fieldTypes.payment_link_radio'
      }),
      tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'editor.options.payment.tooltip'
      }),
      tooltipPlacement: "right",
      children: /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx(OptionsTable, {
          addOption: addPaymentOption,
          disableAddOption: disableAddPaymentOption,
          renderDisableAddOptionReason: /*#__PURE__*/_jsx(DisableAddOptionReason, {
            reason: disableReason
          }),
          formField: paymentField,
          handleUpdate: updatePaymentField,
          handleOnDrag: () => setShowAllOptions(true),
          showAllOptions: showAllOptions,
          use: "light",
          hasOwnDragLayer: true,
          showCustomInternalValueColumn: true,
          TableHeader: PaymentOptionsTableWrapperHeader,
          renderCustomInternalValueColumn: renderPaymentSelectColumn
        }), /*#__PURE__*/_jsx(OptionsTableFooter, {
          formField: paymentField,
          optionsLength: paymentField.options.length,
          shouldShowMore: true,
          shouldShowLess: showAllOptions,
          shouldShowClear: paymentField.selectedOptions.length > 0 && paymentField.options.length > 1,
          handleUpdate: updatePaymentField,
          toggleShowMore: () => setShowAllOptions(!showAllOptions)
        })]
      })
    })
  })
});
export default PaymentOptionsTableWrapper;